// extracted by mini-css-extract-plugin
export default {"info":"InfoComponent_info__uY6LI"};